<template>
	<main v-if="!finalizadoComSucesso">
		<Etapa :dadosComponentes="componentesEtapa" />
		<section>
			<div v-if="!checklistValido"
				class=" my-4 rounded-lg p-4 m-3 shadow-md bg-[#ff8a8a4d] text-[#FF0000] text-center">
				<div class="flex items-center">
					<Icone :nome="'warning'" />
					<div>INFORMAÇÕES PENDENTES</div>
				</div>
				<div class="text-start">Volte até a etapa dos itens pendentes</div>
			</div>

			<div>
				<DadosAtendimento :resumo="true" />
				<div v-if="checklistValido && Object.keys(componentesResumo).length > 0">
					<div v-for="modulo in componentesResumo" :key="modulo.idChecklistModulo">
						<h3 class="text-lg font-semibold text-[#1A689C] px-4 my-2">Checklist {{
							modulo.localRealizacao[0].toUpperCase() + modulo.localRealizacao.substring(1) }}</h3>
						<ResumoModulos :modulos="componentesResumo" />
					</div>
				</div>
				<h3 class="text-lg font-semibold text-[#1A689C] px-4 my-2">Checklist {{ localRealizacao[0].toUpperCase()
					+ localRealizacao.substring(1) }}</h3>
				<component v-for="(componente, identificador) in dadosRespostas" :key="identificador"
					:is="componente.chave" v-bind="componente" :etapaComponente="componente.etapa"
					:localRealizacao="localRealizacao" :modulo="modulo" :resumo="true" />
				<Assinatura v-if="checklistValido" :modulo="modulo" :resumo="true" />
			</div>
		</section>
	</main>
	<footer v-if="!finalizadoComSucesso">
		<div v-if="!exibirLoader">
			<Botoes v-if="!preview" :exibirSalvar="checklistValido && assinado && checklistFinalizado != 'S'"
				:exibirVoltar="etapaAtual != 1 && checklistFinalizado != 'S'" @aoSalvar="salvarChecklist"
				@aoVoltar="voltarEtapa" labelSalvar="Finalizar Checklist"></Botoes>
		</div>
		<div v-else class="flex flex-col justify-center items-center gap-1 mb-8">
			<Loader></Loader> <span class="text-sm">Aguarde</span>
		</div>
	</footer>
	<main v-if="finalizadoComSucesso">
		<div class="card flex-container items-center">
			<div class="flex flex-col justify-center items-center gap-y-2">
				<h1 class="text-xl font-medium pt-8">Checklist finalizado com sucesso!</h1>
				<p class="font-medium">O PDF do checklist estará disponível para download em breve.</p>
			</div>
			<img class="w-44 h-w-44" src="@/assets/sucess.gif" alt="">
		</div>
	</main>
</template>

<script>
import { defineComponent } from 'vue'

import Etapa from '@/components/Etapa.vue'
import Icone from '@/components/Icone.vue';
import Formulario from '@/common/Formulario.vue';
import OpcaoUnica from '@/common/OpcaoUnica.vue'
import Texto from '@/common/Texto.vue';
import TextoGrande from '@/common/TextoGrande.vue';
import Foto from '@/common/foto/Foto.vue';
import Avaria from '@/common/avaria/Avaria.vue';
import EstadoPneu from '@/common/EstadoPneu.vue';
import Acessorio from '@/common/acessoriosEquipamentos/Acessorio.vue';
import Combustivel from '@/common/combustivel/Combustivel.vue';
import Assinatura from '@/common/assinatura/Assinatura.vue';
import DadosAtendimento from '@/common/dadosAtendimento/DadosAtendimento.vue'
import Loader from '@/components/Loader.vue'
import Botoes from '@/components/Botoes.vue';
import ResumoService from '@/services/ResumoService';
import FuncoesHelper from '@/helpers/FuncoesHelper';
import Actions from '@/store/Actions'
import ResumoModulos from '@/components/ResumoModulos.vue';
import Rotas from '@/router/Rotas';

/* eslint-disable vue/no-unused-components */
/* eslint-disable no-unused-vars */
export default defineComponent({
	name: 'Resumo',
	components: {
		Etapa,
		Loader,
		Icone,
		Assinatura,
		DadosAtendimento,
		Formulario,
		Foto,
		Avaria,
		EstadoPneu,
		Acessorio,
		Combustivel,
		Texto,
		TextoGrande,
		OpcaoUnica,
		Botoes,
		ResumoModulos
	},
	methods: {
		voltarEtapa() {

			let etapaAnterior = Object.entries(this.dadosComponentes).filter(([etapas, componentes]) => Object.values(componentes).length > 0)
			etapaAnterior = etapaAnterior.length > 0 ? etapaAnterior[etapaAnterior.length - 1][0] : null

			FuncoesHelper.pushRouter(Rotas.ETAPAS.nome, {
				identificador: this.identificador,
				modulo: this.modulo,
				localRealizacao: this.localRealizacao,
				etapa: etapaAnterior
			})
		},
		salvarChecklist() {
			if (!(this.checklistValido && this.assinado && this.checklistFinalizado != 'S')) return
			this.exibirLoader = true

			this.$store.dispatch(Actions.FINALIZAR_CHECKLIST, { modulo: this.modulo })
				.then(() => {
					this.finalizadoComSucesso = true
				})
				.catch((error) => {
					console.error(error)
					FuncoesHelper.notificar('error', 'Erro', 'Erro ao salvar checklist')
					this.exibirLoader = false
				})
		}
	},
	setup() {
		return ResumoService.setup()
	}
})
</script>